<div style="pointer-events: auto;">
 <div class="map-tools">
  <div class="action-item-text xsmall">Map Tools</div>
  <div class="action-item-container">
    <div class="action-item">
      <a href="#"title="{{'Map-tool.bottombox.zoomin'|translate}}" aria-label="Zoom In" data-mainPageTabbing="yes" (click)="zoomIn()">
        <mat-icon class="icon-new icon-new-select" svgIcon="zoom-in"></mat-icon>
      </a>
    </div>
    <div class="action-item">
      <a href="#" title="{{'Map-tool.bottombox.zoomout'|translate}}" aria-label="Zoom Out" data-mainPageTabbing="yes" (click)="zoomOut()">
        <mat-icon class="icon-new icon-new-select" svgIcon="zoom-out"></mat-icon>
      </a>
    </div>
    <div class="action-item">
      <a href="#" title="{{'Map-tool.bottombox.zoomtoextent'|translate}}" aria-label="Zoom to Region Extent" class="i-inactive" data-mainPageTabbing="yes" (click)="zoomExtent()">
        <mat-icon class="icon-new icon-new-select" svgIcon="zoom-out-2"></mat-icon>
      </a>
    </div>
    <div class="action-item">
      <a href="#" title="{{'Map-tool.bottombox.zoomselected'|translate}}" aria-label="Zoom to Selected" data-mainPageTabbing="yes" class="i-inactive"  (click)="zoomSelected()">
        <mat-icon class="icon-new icon-new-select" svgIcon="zoom-in-2"></mat-icon>
      </a>
    </div>
    <div class="action-item">
      <a href="#" title="{{'Map-tool.bottombox.overviewmap'|translate}}" aria-label="Show Overview Map" class="i-inactive" data-mainPageTabbing="yes" (click)=" mapInset(true, null)">
        <mat-icon class="icon-new icon-new-select" svgIcon="picture_in_picture_alt"></mat-icon>
      </a>
    </div>
    <div class="action-item">
      <a href="#" title="{{'Map-tool.bottombox.triview'|translate}}" class="i-inactive" aria-label="Street View (click map at location of interest)" data-mainPageTabbing="yes" (click)="triView($event)">
        <mat-icon [ngClass]="{ 'i-active': clickTriView }" class="icon-new icon-new-select" svgIcon="street-view" [ngStyle]="{ 'background-color': clickTriView ? '#124DBA' : 'transparent' }"></mat-icon>
      </a>
    </div>
    <div class="action-item" *ngIf="currentUser.clientId === 509">
      <a href="#" title="View Lidar Data" aria-label="View Lidar Data" class="i-inactive" data-mainPageTabbing="yes" (click)="toggleViewLidar()">
        <mat-icon [ngStyle]="{'color': eventEmitterService.viewLidarData ? '#0D399A':'#323237'}" class="icon-new icon-new-select">radar</mat-icon>
      </a>
    </div>
    <div class="action-item" >
      <a href="#" title="{{'Map-tool.bottombox.locate'|translate}}" aria-label="Show current location on map" class="i-inactive" data-mainPageTabbing="yes" (click)="initLocationButton()">
        <mat-icon [ngClass]="{ 'i-active': geolocateActive }" class="icon-new icon-new-select" svgIcon="location"  [ngStyle]="{ 'background-color': geolocateActive ? '#124DBA' : 'transparent' }"></mat-icon>
      </a>
    </div>
  </div>
</div>


  
</div>
